import ChatBot from "react-chatbotify";
import styled from "@emotion/styled";
import React from "react";
import { Flow } from "./Chatbot/Conversation";
import { Settings } from "./Chatbot/Settings";



export const Crea8ifyBot = () =>{
    return (
        // 
        <ChatBot
        settings={Settings}
        flow={Flow}
        />
      );
};